import React, { Component } from 'react';
import {setlog} from "@modules/58m";
import createMsg from "@modules/createMsg";
import {actions} from "@modules/wrap-redux/index";
import fetchJsonp from 'fetch-jsonp';
export default class jobCards extends Component{
    constructor(props){
        super();
        this.state = {
            deliveryList: []
        };
      }
    deliverypost(index,item,event){
        event.stopPropagation();
        const postInfo = this.props.jobCards[index];
        if(window.delivery_new){
            let params = {
                infoId: postInfo.infoid,
                deliverySource: 67,
                tjFrom: postInfo.tjfrom,
                finalCp: '',
                cateId: '',
                sid: '',
                psid: '',
                role: '',
                displayGuideBox: false,
                deliveryCallBackFn: ()=>{
                    let haddelivery = this.state.deliveryList;
                    haddelivery.push(index);
                    this.setState({
                        deliveryList: haddelivery
                    })
                }
            }
            setlog("tjapplyclick",{infoid:postInfo.infoid,tjfrom:postInfo.tjfrom});
            window.delivery_new(params)
             
        }else{
            alert('啊哦，出错了，请刷新页面试试')
        }
        this.clickReport(item);
        //onClick={_this.deliverypost.bind(_this,index)}
    }
    changePost=()=>{
        setlog("mchatbot_change_click");
        
        let msg = createMsg({value:"换一换"});
        actions.chatAreaData.sendMsg({data:msg});
    }
    goToDetail=(index,event)=>{
        event.stopPropagation();
        const postInfo = this.props.jobCards[index];
        
        setlog("zpbrainrec_joblisttjm",{infoid:postInfo.infoid,tjfrom:postInfo.tjfrom});
        window.location.href = postInfo.mobileurl;
    }
    renderWelfares=(item,index)=>{
        if(typeof item == "string"){
            return <span className="welfare-item" key={"welfare"+index}>{item}</span>;
        }else{
            return <span className="welfare-item" key={"welfare"+index}>{item.name}</span>;
        }
    }
    // 帖子计费
    clickReport(item) {
        if(item.charge_url){
            fetchJsonp(item.charge_url);
        }
    }
   componentDidMount(){
       setTimeout(()=>{
         this.deliveryInitStatus();
       },200)
   }
   deliveryInitStatus(){
        const {jobCards = []}= this.props;
        let deliveryList = [];
        jobCards.forEach((item,index)=>{
            if(String(item.isdelivery)==='1'){
                deliveryList.push(index);
            }
        })
        this.setState({
            deliveryList
        })
   }
    render(){
        const {jobCards=[]}= this.props;
        const deliveryList = this.state.deliveryList || [];
        let _this = this;
        //console.log(jobCards)
        return (
            <div className="chatpanel-item chatpanel-item-card-post">
            <div className="item-container">
                <div className="item-content-wrap" id="job-card-content">
                    {
                      jobCards.length ? (jobCards.map((item,index)=>{
                            return (
                                <div className="item-content item-content-data" key={index} onClick={_this.goToDetail.bind(_this,index)} >
                                    <div className="post-title">{item.title}</div>
                                    <div className="post-salary">{item.salary}</div>
                                    <div className="post-company">{item.company}</div>
                                    <div className="post-welfare">
                                    {Array.isArray(item.welfares)&&item.welfares.map((item,index) =>{
                                        return _this.renderWelfares(item,index)
                                    })}
                                    </div>
                                    <div className={`btn-post-delivery ${deliveryList&&deliveryList.indexOf(index) > -1 ?'done':''}`} onClick={_this.deliverypost.bind(_this,index,item)}>{deliveryList&&deliveryList.indexOf(index) > -1 ? '已申请':'申请'}</div>
                            </div>
                            )
                        })):<div className="item-content item-content-no-data">暂无数据</div>
                    }
                    {
                        jobCards.length ? (<div className="item-content item-change" onClick={_this.changePost}>
                        <div className="iconfont icon-refresh_robot_icx item-change-icon"></div>
                        <div className="item-change-txt">换一换</div>
                      </div>):""
                    }
                  
                </div>
            </div>
          </div>
        )
    }
}